import React from 'react'
import AmazingProductSection from '../AmazingProductSection/AmazingProductSection'
import DealCarousel from '../DealCarousel/DealCarousel'
import Feature from '../Feature/Feature'
import LatestProduct from '../LatestProducts/LatestProduct'

const HomePageSideBar = () => {
  return (
    <>
     <h2 className="title1">Deal off the week</h2>
      <DealCarousel/>
      <AmazingProductSection/>
      <LatestProduct/>
      <Feature/>
    </>
  )
}

export default HomePageSideBar